// extracted by mini-css-extract-plugin
export default {"pretitle":"title_pretitle__tPqIT","secondary":"title_secondary__Gobuz","title":"title_title__BSP5m"};